import pt from '@/lang/pt.js'
import en from '@/lang/en.js'

export default {pt, en}